import {
  API_ERROR,
  SECTION,
  SECTION_LIST_SUCCESSFUL,
  SECTION_ADD,
  SECTION_ADD_SUCCESSFUL,
  SECTION_EDIT,
  SECTION_EDIT_SUCCESSFUL,
  SECTION_DELETE,
  SECTION_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

export const getSections = () => {
   return {
    type: SECTION,
  };
};

export const SectionListSuccessful = (section) => {
  return {
    type: SECTION_LIST_SUCCESSFUL,
    payload: section,
  };
};

export const SectionAdd = (section, history) => {
   return {
    type: SECTION_ADD,
    payload: { section, history },
  };
};

export const SectionAddSuccessful = (response) => {
   return {
    type: SECTION_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const SectionEdit = (data) => {
  return {
    type: SECTION_EDIT,
    payload: data,
  };
};

export const SectionEditSuccessful = (response) => {
    return {
      type: SECTION_EDIT_SUCCESSFUL,
      payload: response,
    };
  };

export const SectionDelete = (SectId, history) => {
  return {
    type: SECTION_DELETE,
    payload: { SectId, history },
  };
};

export const SetEditData = (data) => {
  return {
    type: SECTION_SETROWDATA,
    payload: data,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
